export const white = '#FFFFFF';

export const black = '#000000';

export const logoMain = '#214C62';

export const logoSecondary = '#6A8687';

export const logoLighter = '#A9C3C3';
